export type PermissionLevel = 'None' | 'Read' | 'Write';

// Zugriff deliberately excluded — never a valid token scope
// (docs/KONZEPT-Developer-Platform.md, Sicherheitsinvariante 2). The server enforces
// this independently; omitting it here just keeps the picker from ever offering it.
export type ScopeFeature =
  | 'Unternehmen'
  | 'Mitarbeiter'
  | 'Abteilungen'
  | 'Geraete'
  | 'TableStack'
  | 'Rechnungen'
  | 'Support'
  | 'Speisekarte';

export const ALL_SCOPE_FEATURES: ScopeFeature[] = [
  'Unternehmen', 'Mitarbeiter', 'Abteilungen', 'Geraete', 'TableStack', 'Rechnungen', 'Support', 'Speisekarte',
];

export interface TokenScope {
  feature: ScopeFeature;
  level: PermissionLevel;
}

export interface DeveloperApiToken {
  id: string;
  name: string;
  tokenPrefix: string;
  scopes: TokenScope[];
  expiresAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
  /** Only present in the immediate response to createToken() — never persisted, never returned again. */
  rawToken?: string | null;
}

export interface CreateTokenRequest {
  name: string;
  scopes: TokenScope[];
  expiresInDays?: number | null;
}

export interface TokenUsageEntry {
  method: string;
  path: string;
  statusCode: number;
  occurredAt: string;
}

export interface TenantLogEntry extends TokenUsageEntry {
  tokenId: string;
  tokenName: string;
}
